import {NgModule} from '@angular/core';
import {ClauseAndSectionOptionsPipe} from './clause-and-section-options.pipe';

@NgModule({
  declarations: [ClauseAndSectionOptionsPipe],
  exports: [ClauseAndSectionOptionsPipe],
})
export class ClauseAndSectionOptionsModule {}
